// Attachment roles for authenticated Media Library images.
export const MEDIA_ROLES = [
  "primary", "portrait", "hero", "thumbnail", "context", "alternate",
  "supporting_evidence",
  "timeline", "location", "document_preview", "connection", "gallery",
  "background_reference", "internal_only",
];

export const MEDIA_TARGET_TYPES = [
  "dossier", "person", "organization", "location", "event",
  "document", "evidence", "connection", "relationship",
];

// Map Epstein-network entity kinds → media attach target types.
export const kindToMediaType = (kind) => {
  const k = (kind || "").toLowerCase();
  if (MEDIA_TARGET_TYPES.includes(k)) return k;
  if (k === "property" || k === "place" || k === "island") return "location";
  return "connection";
};
